export default "__VITE_ASSET__np4LjxiN__"